import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu"; // Ensure you have imported MenuIcon
import { Link } from "react-router-dom";
import { ConsultantuseAuth } from "../../../security/ConsultantUseAuth";
import GetClientAddress from "../../../../functions/GetClientAddress";
import { useEffect, useState } from "react";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";

function ConsultantHeader({ isOpen, toggleDrawer, screenWidth }) {
  const { logoutConsultant } = ConsultantuseAuth();

  const handleLogout = () => {
    logoutConsultant();
  };

  function handleOpenBespokeForm() {
    window.open(
      `${GetClientAddress()}Public/RegistrationForm/${localStorage.getItem(
        "Consultant_id"
      )}`
    );
  }

  const [obj_EC, setobj_EC] = useState({});
  useEffect(() => {
    const fetchECData = async () => {
      Get_One_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        setobj_EC,
        logoutConsultant
      );
    };
    fetchECData();
  }, []);

  return (
    <>
      {/* W3 CSS */}
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <AppBar
        position="static"
        //  color="primary"
        sx={{
          backgroundColor: "primary",
        }}
        elevation={4}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
            sx={{
              width: "40px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            <MenuIcon />
          </IconButton>
          Navigation
          <a
            onClick={handleOpenBespokeForm}
            className="w3-button w3-circle w3-teal"
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              borderRadius: "10px",
            }}
          >
            Welcome{" "}
            {obj_EC.BasicInfo?.First_Name
              ? obj_EC.BasicInfo?.First_Name + ", "
              : ""}{" "}
            Book Now +
          </a>
          <Box
            sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              color="inherit"
              component={Link}
              to="/Consultant"
              sx={{
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              Home
            </Button>

            <Button
              color="inherit"
              sx={{
                width: "40px",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.2)",
                },
              }}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
}

export default ConsultantHeader;
